import { render, staticRenderFns } from "./Preview_history.vue?vue&type=template&id=e388d580"
import script from "./Preview_history.vue?vue&type=script&lang=js"
export * from "./Preview_history.vue?vue&type=script&lang=js"
import style0 from "./Preview_history.vue?vue&type=style&index=0&id=e388d580&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports